module.exports = __webpack_public_path__ + "img/logo.304bbd30.svg";